import { base } from './';
import {
  IEventSchedule,
  PatchEventSchedulePublishedType,
  PutEventScheduleType,
} from 'types';

const PATH = (eventId: number) => `/events/${eventId}/schedule`;

const get = (eventId: number) => base.get<IEventSchedule>(PATH(eventId));

const put = ({ eventId, ...data }: PutEventScheduleType) =>
  base.put<IEventSchedule>(PATH(eventId), data);

const patchPublished = ({
  eventId,
  published,
}: PatchEventSchedulePublishedType) =>
  base.patch<IEventSchedule>(`${PATH(eventId)}/published`, { published });

export { get, put, patchPublished };
